import { QueryKeys } from '../../../enums/queryKeys'
import { RecurringInvoicesQueryProps } from '../types/recurringInvoicesQueryProps'

export const getRecurringInvoicesQueryKey = (
  queryProps: RecurringInvoicesQueryProps,
): [QueryKeys, RecurringInvoicesQueryProps] => [QueryKeys.RecurringInvoices, queryProps]
